import { render, staticRenderFns } from "./sealPosition.vue?vue&type=template&id=672cdaf9"
import script from "./sealPosition.vue?vue&type=script&lang=js"
export * from "./sealPosition.vue?vue&type=script&lang=js"
import style0 from "./sealPosition.vue?vue&type=style&index=0&id=672cdaf9&prod&lang=scss"
import style1 from "./sealPosition.vue?vue&type=style&index=1&id=672cdaf9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports